import { useCreateEntity, useDeleteEntity, useGetEntity, useUpdateEntity } from '@abaninja/util-store';

import { createAccount, deleteAccount, getAccount, updateAccount } from '../accounts';

export const useAccountStore = () => ({
  ...useCreateEntity(createAccount),
  ...useGetEntity(getAccount),
  ...useUpdateEntity(updateAccount),
  ...useDeleteEntity(deleteAccount),
});
